<template lang="pug">
section.promo
  .promo__video(v-if="false")
    video(preload="auto", muted="", autoplay="", loop="", data-keepplaying="")
      source(src="~@/assets/video/bg.mp4", type="video/mp4")
      source(src="~@/assets/video/bg.webm", type="video/webm")
  .promo__logo
    img(:src="getImageSrc('la-logo.png')", :alt="$t('meta.og_site_name')")

  .promo__inner(
:class="user",
    @mouseenter="enableParallax()",
    @mouseleave="disableParallax()",
  )
    .promo__content
      .promo__button
        button.button.button-big(@click="openReg")
          span {{ $t(`promo.button.${user}`) }}

      .promo__cards(ref="parallax_container", :class="user")
        .promo__card.promo__card--1(data-depth="0.1")
          template(v-if="isNewUser")
            BannerLink(
              v-if="getBannersData('update')",
              :class="getAdditionalClass(user, 'card1')",
              :image="'card1'",
              :title="$t(`promo.card1.new.title`)",
              :text="$t(`promo.card1.new.text`)",
              :video="$t(`promo.card1.new.video`)",
              :user="user",
              @showVideo="showVideo"
            )
          template(v-else)
            BannerLink(
              v-if="getBannersData('update')",
              :class="getAdditionalClass(user, 'card1')",
              :link="getBannersData('update').url",
              :image="getBannersData('update').image",
              :title="getBannersData('update').title",
              :user="user",
            )
        .promo__card.promo__card--2(data-depth="0.1")
          BlockNoPrizes(v-if="user==='no_presents'")
          BlockPrizes.square2x2(
v-else,
            :user="user",
            @prizeClick="openReg"
          )
        .promo__card.promo__card--3(data-depth="0.1")
          BannerLink(
            v-if="getBannersData('release')",
            :class="getAdditionalClass(user, 'card3')",
            :link="getBannersData('release').url",
            :image="getBannersData('release').image",
            :title="getBannersData('release').title",
            :user="user",
          )
  VideoPopup(v-if="video_popup", videoType="vk", :videoId="video_popup", @closeVideo="closeVideo")
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import BannerLink from "./blocks/BannerLink";
import BlockPrizes from "./blocks/BlockPrizes";
import BlockNoPrizes from "./blocks/BlockNoPrizes";
import AboutParallaxMixin from "../../../assets/js/AboutParallaxMixin";
import MobileDetection from "@chronos/frontend-base/src/mixins/mobile_detection/MobileDetectionMixin";
import VideoPopup from "@static_promo_pages/common/components/video-popup/vue/VideoPopup.vue";

const { mapGetters } = createNamespacedHelpers("global");

export default {
  name: "Promo",

  components: {
    BlockNoPrizes,
    BlockPrizes,
    BannerLink,
    VideoPopup,
  },

  mixins: [AboutParallaxMixin, MobileDetection],

  props: {
    user: {
      type: String,
      required: true,
    },
    promoLinks: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      video_popup: null,
    };
  },
  computed: {
    ...mapGetters(["isUserInProject", "isUserNotAuthed", "isUserAuthedNotRegistered"]),
    bannersExist() {
      return this.promoLinks.length;
    },
    isNewUser() {
      return this.user === "new";
    },
  },

  methods: {
    openReg() {
      if (this.isUserNotAuthed) {
        this.$authService.showSignup();
      } else if (this.isUserAuthedNotRegistered) {
        this.$authService.showProjectReg();
      } else {
        this.$authService.downloadGameCenter();
      }
    },

    getImageSrc(img) {
      return require(`@/assets/images/${img}`);
    },

    getAdditionalClass(user_status, card) {
      if (
        (user_status === "new" || user_status === "old") &&
        (card === "card1" || card === "card3")
      ) {
        return "square1x1";
      }
      return "";
    },

    showVideo(video) {
      if (this.is_mobile) {
        // window.open(
        //   `https://www.youtube.com/embed/${video}?autoplay=1&amp;rel=0&amp;showinfo=0`, "_blank"
        // );
        let video_link_parts = video.split("_");
        window.open(
          `https://vkvideo.ru/video_ext.php?oid=${video_link_parts[0]}&id=${video_link_parts[1]}&hd=2&autoplay=1`, "_blank"
        );
      } else {
        this.video_popup = video;
      }
    },

    closeVideo() {
      this.video_popup = null;
    },

    getBannersData(type) {
      return this.bannersExist
        ? this.promoLinks.find(item => item.subline === type && item.active)
        : null;
    },
  },
};
</script>
